import createModule from "../createModule"
import view from "./view"
import { Creators } from "modules/share-my-view/model"
import { getSharedLink } from "./selectors"

export default createModule({
  view,
  mapStateToProps: (state) => ({
    sharedLink: getSharedLink(state),
  }),
  actions: {
    ...Creators,
  },
})
